import { render, staticRenderFns } from "./InesView.vue?vue&type=template&id=3c69a744&scoped=true&"
import script from "./InesView.vue?vue&type=script&lang=js&"
export * from "./InesView.vue?vue&type=script&lang=js&"
import style0 from "./InesView.vue?vue&type=style&index=0&id=3c69a744&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c69a744",
  null
  
)

export default component.exports